module.exports = __webpack_public_path__ + "static/media/lifetime.099b6701.svg";